import CONSTANTS from 'utils/constants';
import _ from 'ckLodash';
import utils from 'utils/utils';

function getStartAndEndBlock(range) {
    return {
        startBlock: utils.getBlockParent(range.startPath()),
        endBlock: utils.getBlockParent(range.endPath())
    };
}

function getListsOnStartAndEndPaths(range) {
    return {
        startLists: _.filter(range.startPath().elements, element => element.getName && CKEDITOR.dtd.$list[element.getName()]),
        endLists: _.filter(range.endPath().elements, element => element.getName && CKEDITOR.dtd.$list[element.getName()])
    };
}

function isElementStarFullyInRange(range, element) {
    var rangeWithStart = range.clone();
    rangeWithStart.setStartBefore(element);
    if (range.endPath().contains(element)) {
        //if range is in the same block, we need to check both from start and end
        rangeWithStart.setEndAfter(element);
    }

    return compareRangesText(range, rangeWithStart);
}

function isElementEndFullyInRange(range, element) {
    var rangeWithStart = range.clone();
    rangeWithStart.setEndAfter(element);
    if (range.startPath().contains(element)) {
        //if range is in the same block, we need to check both from start and end
        rangeWithStart.setStartBefore(element);
    }

    return compareRangesText(range, rangeWithStart);
}

function getBlocks(range, includePartiallySelectedBlocks) {
    if (!range) {
        return [];
    }

    var borderBlocks = getStartAndEndBlock(range);
    if (!borderBlocks) {
        return [];
    }

    const foundElements = [];
    if (includePartiallySelectedBlocks || isStarBlockFullyInRange(range)) {
        foundElements.push(borderBlocks.startBlock);
    }

    if (isRangeOnSameBlockElement(borderBlocks)) {
        return foundElements;
    }

    var domWalker = new CKEDITOR.dom.walker(range);
    while (domWalker.next() && !isEndBlockElement(domWalker.current, borderBlocks.endBlock)) {
        if (shouldApplyCallback(domWalker.current)) {
            foundElements.push(domWalker.current);
        }
    }

    if (includePartiallySelectedBlocks || isEndBlockFullyInRange(range)) {
        foundElements.push(borderBlocks.endBlock);
    }
    return _.uniqBy(foundElements, element => element.$);
}

function getLists(range, includePartiallySelectedLists) {
    if (!range) {
        return [];
    }
    const foundElements = [];
    var borderBlocks = getListsOnStartAndEndPaths(range);

    _.forEach(borderBlocks.startLists, listElement => {
        if (includePartiallySelectedLists || isElementStarFullyInRange(range, listElement)) {
            foundElements.push(listElement);
        }
    });

    var domWalker = new CKEDITOR.dom.walker(range);
    const rangeEndPath = range.endPath();
    while (domWalker.next()) {
        if (domWalker.current && !rangeEndPath.contains(domWalker.current) && isListElement(domWalker.current)) {
            foundElements.push(domWalker.current);
        }
    }
    _.forEach(borderBlocks.endLists, listElement => {
        if (includePartiallySelectedLists || isElementEndFullyInRange(range, listElement)) {
            foundElements.push(listElement);
        }
    });
    return _.uniqBy(foundElements, element => element.$);
}

function getListItems(range, includeStartItem = true) {
    let lisInStartPath = [];
    if (includeStartItem || isStarBlockFullyInRange(range)) {
        lisInStartPath = _.filter(range.startPath().elements, isListItemElement);
    }
    var listItemsInRange = [...getAllElementsInRange(range, isListItemElement), ...lisInStartPath];
    return _.uniqBy(listItemsInRange, element => element.$);
}

function isEndBlockElement(block, endBlock) {
    return _.isEqual(block.getUniqueId(), endBlock.getUniqueId());
}

function isRangeOnSameBlockElement(borderBlockElements) {
    return _.isEqual(borderBlockElements.startBlock.getUniqueId(), borderBlockElements.endBlock.getUniqueId());
}

function shouldApplyCallback(currentElement) {
    return currentElement && currentElement.getName && !_.isEqual(currentElement.type, CKEDITOR.NODE_TEXT) && !utils.isListElement(currentElement.getName()) && utils.isBlockElement(currentElement.getName());
}

function isListElement(currentElement) {
    return CKEDITOR.dtd.$list[_.result(currentElement, 'getName')];
}

function isListItemElement(currentElement) {
    return CKEDITOR.dtd.$listItem[_.result(currentElement, 'getName')];
}

function getText(range) {
    var domWalker = new CKEDITOR.dom.walker(range);
    var res = '';
    var node;
    while ((node = domWalker.next())) {
        if (node.type === CKEDITOR.NODE_TEXT) {
            if (node.getUniqueId() === range.endContainer.getUniqueId() && node.getUniqueId() === range.startContainer.getUniqueId()) {
                res = res + node.getText().substring(range.startOffset, range.endOffset);
            } else if (node.getUniqueId() === range.endContainer.getUniqueId()) {
                res = res + node.getText().substring(0, range.endOffset);
            } else if (node.getUniqueId() === range.startContainer.getUniqueId()) {
                res = res + node.getText().substring(range.startOffset, node.getText().length);
            } else {
                res = res + node.getText();
            }
        }
    }
    return res;
}

function countBrInRange(range) {
    var walker = new CKEDITOR.dom.walker(range);
    var node,
        result = 0;

    while (node = walker.next()) {
        if (node.type === CKEDITOR.NODE_ELEMENT && node.getName() === 'br') {
            result++;
        }
    }
    return result;
}

function isRangeInsideElement(range, element) {
    var startInElement = range.startPath().contains(element);
    var endInElement = range.endPath().contains(element);
    return startInElement && endInElement;
}

/**
 * @param range
 * @param predicate
 * @param isLast - if true, the function will look from the end of the range, else from the start (default)
 * @returns the first node that the predicate returns true for it
 */
function findNode(range, predicate, isLast) {
    var walkerProgressFunction = isLast ? 'previous' : 'next';
    var node,
        result = null;
    var walker = new CKEDITOR.dom.walker(range);
    while (node = walker[walkerProgressFunction]()) {
        if (predicate(node)) {
            result = node;
            walker.end();
        }
    }

    return result;
}

function isNonEmptyTextNode(node) {
    return node.type === CKEDITOR.NODE_TEXT && node.getText().replace(/[\n\r]/g, '').length > 0;
}

function isTextBlock(node) {
    return node.getName && CONSTANTS.TEXT_BLOCKS.indexOf(node.getName()) !== -1;
}

function findFirstNonEmptyTextNode(range) {
    return findNode(range, isNonEmptyTextNode);
}

function findLastNonEmptyTextNode(range) {
    return findNode(range, isNonEmptyTextNode, true);
}

function findFirstTextBlock(range) {
    return findNode(range, isTextBlock);
}

function findLastTextBlock(range) {
    return findNode(range, isTextBlock, true);
}

function getElementFromRange(range, tagName, shouldGetFirst) {
    var domWalker = new CKEDITOR.dom.walker(range);
    var node = domWalker.next();
    var rightEdgeElement;

    while (node) {
        if (_.result(node, 'getName') === tagName) {
            if (shouldGetFirst) {
                return node;
            }
            rightEdgeElement = node;
        }
        node = domWalker.next();
    }
    return rightEdgeElement;
}

function getAllElementsInRange(range, shouldIncludeNode) {
    var domWalker = new CKEDITOR.dom.walker(range);
    var node = domWalker.next();
    var collectedElements = [];

    while (node) {
        if (shouldIncludeNode(node)) {
            collectedElements.push(node);
        }
        node = domWalker.next();
    }
    return collectedElements;
}

function compareRangesText(range, otherRange) {
    var originalText = getText(range);
    var otherText = getText(otherRange);
    return originalText === otherText;
}

function isStarBlockFullyInRange(range) {
    var rangeWithStart = range.clone();
    var startAndEndBlock = getStartAndEndBlock(range);
    rangeWithStart.setStartBefore(startAndEndBlock.startBlock);
    if (_.isEqual(startAndEndBlock.startBlock.getUniqueId(), startAndEndBlock.endBlock.getUniqueId())) {
        //if range is in the same block, we need to check both from start and end
        rangeWithStart.setEndAfter(startAndEndBlock.endBlock);
    }

    return compareRangesText(range, rangeWithStart);
}

function isEndBlockFullyInRange(range) {
    var rangeWithEnd = range.clone();
    var startAndEndBlock = getStartAndEndBlock(range);
    rangeWithEnd.setEndAfter(startAndEndBlock.endBlock);
    if (_.isEqual(startAndEndBlock.startBlock.getUniqueId(), startAndEndBlock.endBlock.getUniqueId())) {
        //if range is in the same block, we need to check both from start and end
        rangeWithEnd.setStartBefore(startAndEndBlock.startBlock);
    }

    return compareRangesText(range, rangeWithEnd);
}

function getTextNodesInSelection(range) {
    var domWalker = new CKEDITOR.dom.walker(range);
    var res = [];
    var node;
    while ((node = domWalker.next())) {
        if (node.type === CKEDITOR.NODE_TEXT) {
            res.push(node);
        }
    }
    return res;
}

function createRange(root, startContainer, startOffset, endContainer, endOffset) {
    var range = new CKEDITOR.dom.range(root);
    range.setStart(startContainer, startOffset);
    if (endContainer) {
        range.setEnd(endContainer, endOffset);
    }
    return range;
}

export default {
    countBrInRange,
    createRange,
    findFirstNonEmptyTextNode,
    findFirstTextBlock,
    findLastNonEmptyTextNode,
    findLastTextBlock,
    getAllElementsInRange,
    getElementFromRange,
    getBlocks,
    getListItems,
    getLists,
    getStartAndEndBlock,
    getText,
    getTextNodesInSelection,
    isRangeInsideElement,
    isStarBlockFullyInRange,
    isEndBlockFullyInRange
};
